import React from 'react';
import * as moment from 'moment';
export default function ({ highlightsfeed, eleRef }) {
    return (

      <div>
         {highlightsfeed.data.length > 0?
          <section className="main_container_block_feeds">
          <div className="main_block_container_feed">
             <div className="block_container_feed_heading_text R15_61">
               <span className=""> {highlightsfeed.title?highlightsfeed.title:''} </span> 
              </div>
              <div className="content-div-box-artical">
               <div className="due_date_Calculater_main_style"> 
                  <div className="content-div_view_artical">
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Due Date Bg.webp"  alt="logo"/>
                  </div>
                  <div className="due_date_Calculater_15 due_date_fontstyle"> {(highlightsfeed.data && highlightsfeed.data[0].date)?moment(highlightsfeed.data[0].date).format('DD'):'' } </div>
                  <div className="due_date_Calculater_16 due_date_fontstyle"> {(highlightsfeed.data && highlightsfeed.data[0].date)?moment(highlightsfeed.data[0].date).format('MMM'):''} </div>
                  <div className="due_date_Calculater_17 due_date_fontstyle"> {(highlightsfeed.data && highlightsfeed.data[0].date)?moment(highlightsfeed.data[0].date).format('YYYY'):''} </div>
                </div>
              
              <div className="due_dates_based_view_lamp"> 
                 <div className="due_dates_based-top-lamp">
                 <div className="due_dates_based_view_method"> 
                        <div className="due_dates_based_period"> 
                         <span className="due_datesharicon"> 
                              <span className="icon select-all checkbox checkAll" data-icon-font="+" id="setpic" value="0" onClick={(e) => { actions.pisTestdone(e) }}> </span>
                          </span>
                         <span className="due_dates_checkmethod B15_white"> {highlightsfeed.dueObj.title?highlightsfeed.dueObj.title:''} </span>
                         <span className="due_datesharicon"> 
                          <div className="icon left" data-icon-font="+"> </div>
                          </span>
                        </div>
                        <div className="due_dates_last_period_view"> 
                          <div className="last_period_view_text"> 
                             <div className="left_last_period_12 R14_42"> 1St Day of your last Period  </div>
                             <div className="right_last_period_12 M14_42"> : {highlightsfeed.dueObj.lmpDate?highlightsfeed.dueObj.lmpDate:''}</div>
                          </div>
                          <div className="last_period_view_text period_desktopviews"> 
                             <div className="left_last_period_12 R14_42"> Average Length of Cycle</div>
                             <div className="right_last_period_12 M14_42"> : {highlightsfeed.dueObj.avgcycledays?highlightsfeed.dueObj.avgcycledays:''} </div>
                          </div>
                        </div>
                        
                      </div>
                 </div>
                 <div className="my_bumpis_prenacy_test_view"> 
                    <div className="bumpis_prenacy_test_steps"> 
                       <div className="left_pega_steps_icon"> 
                         <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Pink.png" alt="logo"/>
                       </div>
                       <div className="right_pega_steps_text"> 
                         <h2 className="M14_61"> {highlightsfeed.data[1].date?highlightsfeed.data[1].date:''}</h2>
                         <p className="R14_61"> {highlightsfeed.data[1].question?highlightsfeed.data[1].question:''} </p>
                       </div>
                    </div>
                    <div className="bumpis_prenacy_test_steps"> 
                       <div className="left_pega_steps_icon"> 
                         <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Yellow.png" alt="logo"/>
                       </div>
                       <div className="right_pega_steps_text"> 
                         <h2 className="M14_61"> {highlightsfeed.data[2].date?highlightsfeed.data[2].date:''}</h2>
                         <p className="R14_61"> {highlightsfeed.data[2].question?highlightsfeed.data[2].question:''} </p>
                       </div>
                    </div>
                    <div className="bumpis_prenacy_test_steps"> 
                       <div className="left_pega_steps_icon"> 
                         <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Blue.png" alt="logo"/>
                       </div>
                       <div className="right_pega_steps_text"> 
                         <h2 className="M14_61"> {highlightsfeed.data[3].date?highlightsfeed.data[3].date:''}</h2>
                         <p className="R14_61"> {highlightsfeed.data[3].question?highlightsfeed.data[3].question:''} </p>
                       </div>
                    </div>
                    <div className="btn_group_join_common btn-common-my-5">
                    <a href={(highlightsfeed.dataApp)?highlightsfeed.dataApp[0].redirectionUrl:''} >
                                             <button className="M16_white mr_b10 gtm-calculate" type="button">{highlightsfeed.dataApp[0].buttonText?highlightsfeed.dataApp[0].buttonText:'CALCULATE'}</button>
                                            </a>
                    </div>
                </div>
              </div>
            </div>
          </div>
      </section>
          
          :

         <div>
           { highlightsfeed.data.length == 0 &&

        <section className="main_container_block_feeds">
                            <div className="main_block_container_feed">
                               <div className="block_container_feed_heading_text R15_61">
                                   {(highlightsfeed.dataApp[0].title)?highlightsfeed.dataApp[0].title:''}
                                </div>
                                <div className="content-div-box-artical desk_top-radius_16">
                                 <div className="due_dates_view_might_be_main"> 
                                    <div className="content-div_view_artical">
                                      <img src={highlightsfeed.dataApp[0].imageUrl} alt="logo"/>
                                    </div>
                                    <div className="feedmy_bumpi_duedates">
                                      <div className="feed_dates_banner_main">
                                      </div>
                                      <div className="feedmy_bumpi_duedates_content">
                                       <div className="M18_white mr_b12">{highlightsfeed.subTitle}</div> 
                                         <div className="week_card-text more mr_b12">
                                            <span className="R14_white game-discription-text"> 
                                                {(highlightsfeed.dataApp[0].descriptionText)?highlightsfeed.dataApp[0].descriptionText:''}
                                            </span>
                                            <a href={(highlightsfeed.dataApp[0].redirectionUrl)?highlightsfeed.dataApp[0].redirectionUrl:''} className="readmorelink R14_white gtm-duedate-readMore"> Read more</a>
                                          </div>
                                          <div className="dates_banner_btn_group_join_common">
                                            <a href={(highlightsfeed.dataApp)?highlightsfeed.dataApp[0].redirectionUrl:''} >
                                             <button className="M16_white mr_b10 gtm-calculate" type="button">{(highlightsfeed.dataApp[0].buttonText)?highlightsfeed.dataApp[0].buttonText:''}</button>
                                            </a>
                                         </div>
                                     </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </section>}
                        </div>
}
      </div>

    )
}
